import { render, staticRenderFns } from "./ExaminationBasicDetailPage.vue?vue&type=template&id=458abbd0&"
import script from "./ExaminationBasicDetailPage.vue?vue&type=script&lang=js&"
export * from "./ExaminationBasicDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationBasicDetailPage.vue?vue&type=style&index=0&id=458abbd0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports